module.exports = __webpack_public_path__ + "img/planet-moon.8b033517.svg";